<template>
  <div class="modal-overlay">
    <div>
      <!--Error message during office hours-->
      <div class="modal-content" v-if="isNowWithinOfficeHours">
        <p>
          We are experiencing a technical issue with our booking engine.
          Apologies for the delay.
          <br /><br />
          Please try again in a few minutes.
          <br /><br />
          For further assistance, contact us on <br />
          +27 21 929 2800.
        </p>
        <div class="search-button-wrapper">
          <b-button
            @click="handleOk()"
            ref="search"
            type="is-primary"
            class="search-button"
            >Ok</b-button
          >
        </div>
      </div>
      <!--Error message after office hours-->
      <div class="modal-content" v-if="!isNowWithinOfficeHours">
        <p>
          We are experiencing a technical issue with our booking engine.
          Apologies for the delay.
          <br /><br />
          Please try again in a few minutes.
        </p>
        <div class="search-button-wrapper">
          <b-button
            @click="handleOk()"
            ref="search"
            type="is-primary"
            class="search-button"
            >Ok</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApiErrorModal",
  data() {
    return {
      isActive: true
    };
  },
  computed: {
    //Checks if now is within office hours for apir error modal custom message
    isNowWithinOfficeHours() {
      const currentHour = new Date().getUTCHours() + 2; // Convert to GMT +2
      const currentDay = new Date().getUTCDay(); // Get the current day (0 = Sunday, 6 = Saturday)
      const isWeekday = currentDay >= 1 && currentDay <= 5; // Monday to Friday
      const isOfficeHours = isWeekday && currentHour >= 8 && currentHour < 17; //office hours from 8am to 5pm weekdays
      if (isOfficeHours) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    handleOk() {
      window.open(
        "https://www.investectravel.com/flights-cars-hotels/",
        "_self"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings.scss";

/* Custom Modal styles */
.modal-overlay {
  backdrop-filter: blur(5px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3); /* semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 12; /* To ensure the modal is above other page content */
}

.modal-content {
  background: white;
  padding: 30px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  width: 420px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 10px;
  align-items: center;
  p {
    text-align: center;
    line-height: 1.5; /* Adjust the line height to add some gap between the text lines */
    font-family: "Inter", sans-serif;
  }
}

@media (max-width: 781px) {
  .modal-content {
    max-width: 350px;
  }
}

.search-button-wrapper {
  display: flex;
  justify-content: center;
  padding-top: 10px;

  .search-button {
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    background-color: #30384a;
    padding: 0 20px;
    border-radius: 24px;
  }
}
</style>
